/* global grecaptcha */
//* This stimulus controller kicks in the v2 recaptcha once its element is initialized
import ApplicationController from "../application_controller.js";

export default class extends ApplicationController  {
  static values = { siteKey: String };

  initialize() {
    this.log_function("initialize");

    const locale = document.querySelector("meta[name='current-locale']").content;
    grecaptcha.render("recaptchaV2", { sitekey: this.siteKeyValue, hl: locale, callback: this.callback.bind(this) } );
  }

  callback(){
    this.log_function("callback");

    window.dispatchEvent(new Event("recaptchaV2--solved"));
  }

}
